export const surveysTableTitles = [
  'User',
  'How did you hear about us?',
  'Reasons for needing a signature guarantee',
  'Additional Comments',
  'Rating',
];
